module.exports = __webpack_public_path__ + "img/landing50.8e817325.jpg";